import { PlanPastDueExamsTransferCtrl } from './plan-past-due-exams-transfer.controller';

export const PlanPastDueExamsStepTransferComponent = {
  controller: PlanPastDueExamsTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./plan-past-due-exams-transfer.html'),
};
